import { CheckIcon } from 'src/assets/icons/CheckIcon';
import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { easeTransform } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';

interface StyledCheckboxPropsType {
    isChecked?: boolean;
    isBackground?: boolean;
    isDisabled: boolean;
}

export const buildCheckboxType = (isChecked: boolean | undefined, isBackground: boolean | undefined): string => {
    if (isChecked === true) {
        return `
            background: ${mainColors.main.secondary};
        `;
    }
    if (isBackground === true) {
        return `
            border: solid 1px ${mainColors.main.secondary};
            background: ${mainColors.default.light};
        `;
    }
    return `
        border: solid 1px ${mainColors.main.secondary};
        background: none;
    `;
};

export const Wrapper = styled('div', { label: 'Wrapper' })`
    display: flex;
`;
export const CheckboxWrapper = styled('span', { label: 'CheckboxWrapper' })<StyledCheckboxPropsType>`
    position: relative;
    align-items: center;
    display: flex;
    justify-content: center;
    flex: 0 0 16px;
    width: 16px;
    height: 16px;
    transition: background-color .2s ease;
    ${(props): string => buildCheckboxType(props.isChecked, props.isBackground)};
    border-radius: 4px;
    ${(props): string => props.isDisabled ? 'pointer-events: none' : 'cursor: pointer;'};
    
    &:focus-visible {
        outline: 2px solid ${mainColors.main.secondary};
        outline-offset: 2px;
    }
    &:focus:not(:focus-visible) {
        outline: none;
    }
`;

export const CheckboxContainer = styled('div', { label: 'CheckboxContainer' })<StyledCheckboxPropsType>`
    position: relative;
    display: flex;
    align-items: center;
    &:first-of-type{
        margin: 0 17px 0 0;
    }
    opacity: ${(props): string => props.isDisabled ? '.4' : '1'};
    ${(props): string => props.isDisabled ? 'cursor: not-allowed' : ''};
`;

interface StyledIconPropsType {
    isChecked: boolean;

}

export const CheckIconWrapper = styled(CheckIcon, { label: 'CheckIconWrapper' })<StyledIconPropsType>`
    position: absolute;
    width: 10px;
    fill: ${mainColors.default.light};
    transform: ${(props): string => props.isChecked ? 'scale(1)' : 'scale(0)'};
    transition: ${easeTransform};
`;

export const LabelTxt = styled('span', { label: 'LabelTxt' })`
    margin-right: 4px;
    font-size: 14px;
`;
